// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bac9d71e","703":"55d4d720","787":"95057f93","885":"c17402c6"}[chunkId] + ".chunk.js";
};